export const HelpCircleIcon = ({ color = '#6A6B76', ...props }) => (
  <svg
    width={'20'}
    height={'20'}
    viewBox={'0 0 20 20'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      d={'M9.9974 18.3385C14.5998 18.3385 18.3307 14.6076 18.3307 10.0052C18.3307 5.40284 14.5998 1.67188 9.9974 1.67188C5.39502 1.67188 1.66406 5.40284 1.66406 10.0052C1.66406 14.6076 5.39502 18.3385 9.9974 18.3385Z'}
      stroke={color}
      strokeWidth={'1.665'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
    <path
      d={'M7.57031 7.49852C7.76623 6.94158 8.15294 6.47194 8.66194 6.1728C9.17094 5.87365 9.76939 5.7643 10.3513 5.86411C10.9332 5.96393 11.461 6.26646 11.8412 6.71813C12.2214 7.1698 12.4295 7.74146 12.4286 8.33186C12.4286 9.99852 9.92865 10.8319 9.92865 10.8319'}
      stroke={color}
      strokeWidth={'1.665'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
    <path
      d={'M10 14.1719H10.0091'}
      stroke={color}
      strokeWidth={'1.665'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
  </svg>

);
